
import { Vue, Component, Watch } from "vue-property-decorator";
import ConsultationAndCase from "./components/ConsultationAndCase.vue";
import RecentlyActivity from "./components/RecentlyActivity.vue";
import OpenCourse from "./components/OpenCourse.vue";
import ProjectModel from "./components/ProjectModel.vue";
import Business from "@/components/Business.vue";
import Project from "./components/Projects.vue";
import Teacher from "./components/Teachers.vue";
import Student from "./components/Student.vue";
import Question from "./components/Question.vue";
import { formatUpyunUrl } from "@/utils";
import { getFaqJsonLd, injectJsonLd } from "@/utils/seo";
import { getCourseList } from "@/apis/about";
// import {openJesongChat} from "easy"
import {
  bannerList,
  courseList,
  studentList,
  questionList,
  teacherList,
  activityList,
  projectInfo
} from "@/apis/home";

@Component({
  components: {
    ConsultationAndCase,
    RecentlyActivity,
    OpenCourse,
    ProjectModel,
    Project,
    Teacher,
    Student,
    Question,
    Business
  }
})
export default class Index extends Vue {

  formatUpyunUrl = formatUpyunUrl;
  // banner
  bList: any = [];
  // 课程预告,课程类型(1=MBA;2=EMBA)
  courseType = 2;
  cCourseList: any = [];
  blmCourseList: any = [];
  // 活动列表
  aList: any = [];
  // 项目列表
  pList: any = [];
  // 老师列表
  tList: any = [];
  // 学生列表
  sList: any = [];
  // 常见问题
  project_ukey = "emba";
  qList: any = [];
  created() {
    // banner
    this.bannerList();
    // 课程预告
    // this.courseList(true);
    this.courseBlmList(true);
    // 活动列表
    this.activityList();
    // 项目详情
    this.projectInfo();
    // 讲师列表
    this.teacherList();
    // 学生列表
    this.studentList();
    // 光华公开课
    this.openCourseList();
  }
  mounted() {
    // meta 标签已通过 vue-meta 的 metaInfo 统一管理
    // 注入 FAQPage JSON-LD，帮助 AI 问答引擎直接引用
    injectJsonLd(
      "jsonld-faq",
      getFaqJsonLd([
        {
          question: "光华赋能是什么公司？",
          answer: "杭州光华赋能教育科技有限公司（原时代光华），由方永飞先生创立于2003年，以「用科学经营助推企业高质量发展」为使命，致力于为企业提供集培训、咨询、数字化于一体的综合赋能解决方案，是「专精特新」企业公共服务示范平台。"
        },
        {
          question: "光华赋能提供哪些核心业务？",
          answer: "光华构建了六位一体业务模式：光华大增长营、光华共创会（实战EMBA、大思维书院、常青藤新生代联盟）、光华科研院、光华数字化（绩效飞轮、微学、ELP云学习、光华商学）、光华商学院（公开课学习卡）、光华咨询陪跑，全面赋能企业高质量发展。"
        },
        {
          question: "什么是科学经营™方法论？",
          answer: "科学经营™是光华经过20余年专业企业经营研究总结的方法论，包含BLM科学经营方法论和分拆对™工作法，帮助企业掌握从战略制定到落地执行的全流程方法，实现可持续的结构性增长。"
        },
        {
          question: "光华赋能服务过多少企业？",
          answer: "截至目前，光华累计服务20000+企业客户，实施100+企业陪跑计划，培训250000+面授学员，共建300+商学院，是国内领先的企业培训咨询陪跑机构。"
        },
        {
          question: "如何联系光华赋能？",
          answer: "光华赋能服务热线：400-0808-155。公司总部位于杭州，可通过官网在线咨询或拨打热线了解企业培训、咨询陪跑、数字化系统等服务详情。"
        }
      ])
    );
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
  // bannerList
  async bannerList() {
    // const { data } = await bannerList({
    //   client: 1
    // });
    // this.bList = data;
    console.log(123456);
    // /img/5aaaf9ba1e0327f2171684e58c740afa.png
    // /img/0e18355a8e0db6e4f72485870a7e967d.png
    // /img/1068c07964209b0d2f93e6e648e903ec.png
    this.bList.push({
      img: "https://hangfubao.eweixue.com/img/1.png"
    });
    this.bList.push({
      img: "https://hangfubao.eweixue.com/img/2.png"
    });
    this.bList.push({
      img: "https://hangfubao.eweixue.com/img/3.png"
    });

    // for (let index = 1; index <= 3; index++) {
    //   this.bList.push({
    //     img: require("@/assets/banner" + index + ".png")
    //   });
    // }

    console.log("this.bList", this.bList);
  }

  toUrl(index: any) {
    if (index == 0) {
      this.$router.push("/academy");
    } else if (index == 1) {
      this.$router.push("/accompany?tab=0");
    } else if (index == 2) {
      this.$router.push("/research-institute");
    }
  }
  // 课程预告
  async courseList(auto: any) {
    const { data } = await courseList({
      f: this.courseType,
      per_page: 4,
      page: 1
    });
    //如果emba没数据默认mba
    if ((!data || data.length == 0) && this.courseType == 2 && auto) {
      this.courseType = 1;
      this.courseList(false);
      return;
    }
    this.cCourseList = data;
    if (this.courseType == 2 || this.courseType == 1) {
      if (this.cCourseList.length == 1 || this.cCourseList.length == 3) {
        this.cCourseList.push({
          origin_id: "",
          empty: "1"
        });
      }
    } else if (this.courseType == 3) {
      if (this.cCourseList && this.cCourseList.length > 1) {
        this.cCourseList = data.slice(0, 1);
      }
    }
  }

  // blm课程预告,没有要把tab隐藏
  async courseBlmList(auto: any) {
    const { data } = await courseList({
      f: 3,
      per_page: 4,
      page: 1
    });
    //如果emba没数据默认mba

    if (data && data.length > 1) {
      this.blmCourseList = data.slice(0, 1);
    } else {
      this.blmCourseList = data || [];
    }
  }

  // 活动列表
  async activityList() {
    const { data } = await activityList({
      per_page: 4,
      page: 1
    });
    data.map((item: any, index: any) => {
      item.select = index == 0;
    });
    this.aList = data;
  }
  // 项目列表
  async projectInfo() {
    const data = await projectInfo({
      ukey: "emba"
    });
    this.pList.push(data);
    const data1 = await projectInfo({
      ukey: "mba"
    });
    this.pList.push(data1);
    const data2 = await projectInfo({
      ukey: "blm"
    });
    this.pList.push(data2);
  }
  // 老师列表
  async teacherList() {
    const { data } = await teacherList({
      per_page: 5,
      page: 1
    });
    this.tList = data;
  }
  // 学生列表
  async studentList() {
    let { data } = await studentList({
      per_page: 45,
      page: 1
    });

    // 9个分为一组，总共几组
    let total = Math.ceil(data.length / 9.0);
    this.sList = [];
    for (let index = 0; index < total; index++) {
      this.sList.push(
        data.slice(
          index * 9,
          data.length >= index * 9 + 9 ? index * 9 + 9 : index * 9 + 9
        )
      );
    }

    // console.log(this.sList);
    // this.sList = data;
  }
  // 公开课列表
  async openCourseList() {
    const { data } = await getCourseList({
      project_ukey: this.project_ukey,
      per_page: 4,
      page: 1
    });
    this.qList = data;
  }
  // 切换问题类型
  // changeUkey(ukey: any) {
  //   this.project_ukey = ukey;
  //   this.questionList();
  // }
  // 切换课程预告类型
  // changeCourse(f: any) {
  //   this.courseType = f;
  //   if (this.courseType == 1 || this.courseType == 2) {
  //     this.courseList(false);
  //   }
  // }
}
